import * as css from './FrachtTable.css'